import { render, staticRenderFns } from "./EditBaseProfilExclusion.vue?vue&type=template&id=2eff7d1c&"
import script from "./EditBaseProfilExclusion.vue?vue&type=script&lang=ts&"
export * from "./EditBaseProfilExclusion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAlert,VForm})
